<template>
  <modal
    elem-id="subscribe"
    :show="isVisible"
    :title="t('Assinar plano')"
    :save-label="t('Assinar')"
    :save-fn="handleSave"
    :save-disabled-fn="isSaveDisabled"
    @close="closeModal"
    @dismiss="closeModal"
  >
    <template v-if="isVisible">
      <div data-testid="subscribe-modal">
        <subscribe-form
          ref="formRef"
          :franquia-id="currentFranquiaId ?? undefined"
        />
      </div>
    </template>
  </modal>
</template>

<script setup lang="ts">
import { ref, onMounted, onBeforeUnmount } from 'vue'
import { useI18n } from 'vue-i18n'
import { eventBus } from '../../eventBus'
import { log } from '../../utils/DebugLogger'
import SubscribeForm from './SubscribeForm.vue'

interface ModalOpenPayload {
  franquia_id?: number
}

interface SubscribeFormExposed {
  handleSubmit: () => Promise<void>
  canSave: { value: boolean } | boolean
}

const { t } = useI18n()

const isVisible = ref(false)
const currentFranquiaId = ref<number | null>(null)
const formRef = ref<SubscribeFormExposed | null>(null)

/** Unwrap canSave regardless of whether the form exposes a ref or a plain boolean. */
function isSaveDisabled(): boolean {
  if (!formRef.value) return true
  const cs = formRef.value.canSave
  if (cs != null && typeof cs === 'object' && 'value' in cs) return !cs.value
  return !cs
}

async function onOpen(payload?: ModalOpenPayload): Promise<void> {
  log('SubscribeModal', 'onOpen', 'Abrindo modal de assinatura', payload)
  currentFranquiaId.value = payload?.franquia_id ?? null
  isVisible.value = true
}

function closeModal(): void {
  log('SubscribeModal', 'closeModal', 'Fechando modal de assinatura')
  isVisible.value = false
  currentFranquiaId.value = null
  eventBus.emit('modal.subscribe.close')
}

async function handleSave(): Promise<void> {
  if (formRef.value) {
    await formRef.value.handleSubmit()
  }
}

onMounted(() => {
  eventBus.on('modal.subscribe.open', onOpen as (data?: unknown) => void)
})

onBeforeUnmount(() => {
  eventBus.off('modal.subscribe.open', onOpen as (data?: unknown) => void)
})
</script>
